(function() {
  'use strict';

  // CUSTOM CURSOR
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var cur = document.getElementById('cursor');
    var cring = document.getElementById('cring');
    if (cur && cring) {
      var mx = 0, my = 0, rx = 0, ry = 0;
      document.addEventListener('mousemove', function(e) {
        mx = e.clientX; my = e.clientY;
        cur.style.left = (mx - 5) + 'px'; cur.style.top = (my - 5) + 'px';
      });
      (function animRing() {
        rx += (mx - rx - 17) * 0.14; ry += (my - ry - 17) * 0.14;
        cring.style.left = rx + 'px'; cring.style.top = ry + 'px';
        requestAnimationFrame(animRing);
      })();
      document.addEventListener('mouseover', function(e) {
        if (e.target.closest('a, button, [data-quick-view], [data-add-to-cart]')) {
          cur.style.transform = 'scale(2.2)'; cring.style.transform = 'scale(1.6)';
          cring.style.borderColor = 'rgba(255,0,144,0.7)';
        }
      });
      document.addEventListener('mouseout', function(e) {
        if (e.target.closest('a, button, [data-quick-view], [data-add-to-cart]')) {
          cur.style.transform = 'scale(1)'; cring.style.transform = 'scale(1)';
          cring.style.borderColor = 'rgba(0,255,234,0.5)';
        }
      });
    }
  }

  // HERO CANVAS
  var canvas = document.getElementById('hero-canvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var t = 0;
    function resize() { canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
    resize(); window.addEventListener('resize', resize);
    function draw() {
      var W = canvas.width, H = canvas.height;
      ctx.clearRect(0, 0, W, H);
      var horizon = H * 0.6, vx = W * 0.5;
      for (var i = 0; i < 20; i++) {
        var p = ((i / 20) + t * 0.0038) % 1, e = p * p;
        var y = horizon + (H - horizon) * e, a = e * 0.5;
        var g = ctx.createLinearGradient(0, y, W, y);
        g.addColorStop(0, 'transparent'); g.addColorStop(0.2, 'rgba(0,255,234,' + a + ')');
        g.addColorStop(0.8, 'rgba(0,255,234,' + a + ')'); g.addColorStop(1, 'transparent');
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(W, y);
        ctx.strokeStyle = g; ctx.lineWidth = e * 1.8; ctx.stroke();
      }
      for (var i = 0; i <= 26; i++) {
        var frac = i / 26, ex = frac * W, sx = vx + (ex - vx) * 0.018;
        var a = 0.12 + Math.sin(t * 0.014 + i * 0.45) * 0.04;
        var spike = Math.sin(t * 0.022 - i * 0.28) > 0.92;
        var g = ctx.createLinearGradient(sx, horizon, ex, H);
        g.addColorStop(0, 'rgba(191,0,255,0)');
        g.addColorStop(0.4, 'rgba(191,0,255,' + (spike ? 0.55 : a * 0.5) + ')');
        g.addColorStop(1, 'rgba(191,0,255,' + (spike ? 0.55 : a) + ')');
        ctx.beginPath(); ctx.moveTo(sx, horizon); ctx.lineTo(ex, H);
        ctx.strokeStyle = g; ctx.lineWidth = spike ? 1.2 : 0.6; ctx.stroke();
      }
      for (var i = 0; i < 3; i++) {
        var p = (t * 0.007 + i * 0.33) % 1;
        var sy = horizon + (H - horizon) * p * p, sa = p * 0.75;
        var g = ctx.createLinearGradient(0, sy, W, sy);
        g.addColorStop(0, 'transparent'); g.addColorStop(0.25, 'rgba(0,255,234,' + (sa * 0.5) + ')');
        g.addColorStop(0.75, 'rgba(0,255,234,' + (sa * 0.5) + ')'); g.addColorStop(1, 'transparent');
        ctx.beginPath(); ctx.moveTo(0, sy); ctx.lineTo(W, sy);
        ctx.strokeStyle = g; ctx.lineWidth = 1.5 + p * 3; ctx.stroke();
      }
      for (var i = 0; i < 70; i++) {
        var px = (Math.sin(i * 137.508 + t * 0.002) * 0.5 + 0.5) * W;
        var py = (Math.cos(i * 97.32) * 0.5 + 0.5) * horizon * 0.88;
        var pa = 0.25 + Math.sin(t * 0.06 + i) * 0.15;
        var ps = 0.4 + Math.sin(i * 19) * 0.4;
        ctx.beginPath(); ctx.arc(px, py, Math.max(0.1, ps), 0, Math.PI * 2);
        ctx.fillStyle = i % 3 === 0 ? 'rgba(0,255,234,' + pa + ')' : i % 3 === 1 ? 'rgba(200,0,255,' + pa + ')' : 'rgba(255,255,255,' + (pa * 0.4) + ')';
        ctx.fill();
      }
      t++; requestAnimationFrame(draw);
    }
    draw();
  }

  // NAV SCROLL
  var nav = document.getElementById('nav');
  if (nav) { window.addEventListener('scroll', function() { nav.classList.toggle('scrolled', window.scrollY > 50); }); }

  // SCROLL REVEAL
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('on'); });
    }, { threshold: 0.08 });
    reveals.forEach(function(el) { obs.observe(el); });
  }

  // MOBILE MENU
  var menuToggle = document.getElementById('mobile-menu-toggle');
  var menuClose = document.getElementById('mobile-menu-close');
  var mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() { mobileMenu.classList.add('open'); });
    if (menuClose) menuClose.addEventListener('click', function() { mobileMenu.classList.remove('open'); });
  }

  // VARIANT SWITCHING
  var productJson = document.getElementById('product-json');
  if (productJson) {
    var product = JSON.parse(productJson.textContent);
    var variantBtns = document.querySelectorAll('.product-detail__variants .variant-btn');
    var variantIdInput = document.getElementById('variant-id');
    var addBtn = document.getElementById('add-to-cart-btn');
    var priceWrapper = document.querySelector('.product-detail__info .price-wrapper');
    var mainImage = document.getElementById('product-image');
    var selectedOptions = {};
    if (product.variants.length > 0) {
      product.options.forEach(function(opt, i) { selectedOptions[i] = product.variants[0].options[i]; });
    }
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optIndex = parseInt(btn.dataset.optionIndex);
        selectedOptions[optIndex] = btn.dataset.value;
        btn.parentElement.querySelectorAll('.variant-btn').forEach(function(b) {
          b.classList.toggle('active', b.dataset.value === btn.dataset.value);
        });
        var match = product.variants.find(function(v) {
          return product.options.every(function(opt, i) { return v.options[i] === selectedOptions[i]; });
        });
        if (match) {
          variantIdInput.value = match.id;
          if (priceWrapper) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              priceWrapper.innerHTML = '<span class="price price--sale">$' + (match.price / 100).toFixed(2) + '</span><span class="price price--compare">$' + (match.compare_at_price / 100).toFixed(2) + '</span>';
            } else {
              priceWrapper.innerHTML = '<span class="price">$' + (match.price / 100).toFixed(2) + '</span>';
            }
          }
          if (match.featured_image && mainImage) mainImage.src = match.featured_image.src;
          if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT'; }
        }
      });
    });
  }

  // THUMBNAIL GALLERY
  var thumbs = document.querySelectorAll('.product-detail__thumb');
  var mainImg = document.getElementById('product-image');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.dataset.imageUrl;
    });
  });

  // QUANTITY CONTROLS
  var qtyInput = document.getElementById('quantity');
  if (qtyInput) {
    document.querySelectorAll('.product-detail__quantity .quantity-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (btn.dataset.action === 'increase') val++; else if (val > 1) val--;
        qtyInput.value = val;
      });
    });
  }
})();
